/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { Url_WebSocket_BuildUrl } from "app/rest-constants";
import { Subject } from "rxjs";
import { AuthenticationService } from "./authentication.service";
import { WebSocketService } from "./websocket.service";

@Injectable()
export class MonitorTags_SelectedTagWebSocketService {

    constructor(
      private authenticationService: AuthenticationService,
      private webSocketService: WebSocketService
    ) { }

    public create(tagId: number): Subject<any> {
      // Get information required to build URL...
      const authToken = this.authenticationService.getToken();
  
      // Build the URL...
      const url = Url_WebSocket_BuildUrl(authToken, `monitor-tags/selected-tag/${tagId}`);
  
      // Create the Web Socket connection / subscription and return it...
      return this.webSocketService.connect(url);
    }

}
